import type { TFunction } from "i18next";

const STATUS_KEY: Record<string, string> = {
  unknown:"statementWorkspace.buckets.unknown",
  paid: "status.paid",
  partial: "status.partial",
  unpaid: "status.unpaid",
  approved: "status.approved",
  pending: "status.pending",
  "under review": "status.underReview",
  rejected: "status.rejected",
  draft: "status.draft",
  active: "status.active",
  inactive: "status.inactive",
  disabled: "status.disabled",
  obsolete: "status.obsolete",
  confirmed: "status.confirmed",
  sent: "status.sent",
  delivered: "status.delivered",
  "partially delivered": "status.partiallyDelivered",
  "in transit": "status.inTransit",
  received: "status.received",
  testing: "status.testing",
  completed: "status.completed",
  "in production": "status.inProduction",
  shipped: "status.shipped",
  closed: "status.closed",
  cancelled: "status.cancelled",
  ordered: "status.ordered",
  in: "status.in",
  out: "status.out",
  transfer: "status.transfer",
  adjust: "status.adjust",
  planned: "status.planned",
  released: "status.released",
  "in progress": "status.inProgress",
  done: "status.done",
  pass: "status.pass",
  fail: "status.fail",
  incoming: "status.incoming",
  "in-process": "status.inProcess",
  final: "status.final",
  asset: "status.asset",
  liability: "status.liability",
  equity: "status.equity",
  revenue: "status.revenue",
  expense: "status.expense",
  low: "status.low",
  medium: "status.medium",
  high: "status.high",
  urgent: "status.urgent",
  open: "status.open",
  resolved: "status.resolved",
  current: "status.current",
};

/** Translate known server enums while preserving unknown business data verbatim. */
export function translateStatus(t: TFunction, value: string): string {
  const key = STATUS_KEY[value.trim().toLowerCase()];
  return key ? t(key) : value;
}
